import { styled } from '@mui/material/styles'

export const AppLogo = styled('img')({
  width: '120px',
  height: 'auto',
})
